import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { SupportModalIdSubComponent } from '@lib/components/support-class';
import { CommonLibService } from '@lib/services';

/**
 * 搭乗者情報入力画面　フッター
 */
@Component({
  selector: 'asw-passenger-information-input-modal-footer',
  templateUrl: './passenger-information-input-modal-footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PassengerInformationInputModalFooterComponent extends SupportModalIdSubComponent {
  constructor(private _common: CommonLibService, private _change: ChangeDetectorRef) {
    super(_common);
  }

  override init(): void {
    /* override abstract init function of base class */
  }

  // [1.17] 更新ボタン
  public isDisabled: boolean = false;
  public handleDisabledBtn() {
    this.isDisabled = true;
    this._change.detectChanges();
  }

  /**
   * 更新するボタン押下時処理
   */
  public onClickApply() {
    if (!this.isDisabled) {
      this.applyEvent();
    }
  }

  public applyEvent: () => Promise<void> = async () => {
    // メインコンポーネントによって渡される
  };

  override reload(): void {
    /* override abstract reload function of base class */
  }

  override destroy(): void {
    /* override abstract destroy function of base class */
  }
}
